export const PickingSquareColors = [
  { id: 1, color: '#48C9B0' },

  { id: 2, color: '#F4D03F' },

  { id: 3, color: '#AF7AC5' },

  { id: 4, color: '#EC7063' },

  { id: 5, color: '#5D6D7E' }
]
export const PickingSquareTitles = [
  { id: 1, subId: 0, title: 'Disponible para picking' },

  { id: 2, subId: 0, title: 'En ruta de picking' },

  { id: 3, subId: 0, title: 'Picking finalizado' },

  { id: 3, subId: 2, title: 'En Validación' },

  { id: 3, subId: 3, title: 'Validación finalizada' }
]

export const cardSize = {
  maxWidth: 220,
  maxHeight: 130
}

export const tipoInforme = [
  {
    id: 1,
    name: 'NO HAY RUTAS DE PICKING PENDIENTES CON LA FECHA CONSULTADA'
  },
  {
    id: 2,
    name: 'NO HAY RUTAS DE PICKING PENDIENTES CON FECHA DE ENTREGA HOY'
  },
  { id: 3, name: 'NO HAY RUTAS DE PICKING PENDIENTES' }
]
